import { graphql } from "@/lib/gql/__generated__";

export const SiteControllerSettingAirHostPricePLan_SettingPage_Query = graphql(`
	query SiteControllerSettingAirHostPricePLan_SettingPage_Query($hotelID: ID!) {
		siteControllerSettingAirHostPricePlanDataFetch(hotelID: $hotelID) {
			userErrors
			airHostPricePlanData {
				airHostPricePlanID
				airHostPricePlanName
				airHostRoomTypeID
				airHostRoomCheckInTime
				airHostRoomCheckOutTime
			}
		}
	}
`);
